import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import {
    Container,
    Content2Xl,
    ContentWithVerticalPadding,
} from "components/misc/Layouts";
import tw from "twin.macro";
//import styled from "styled-components";
//import { LogoLink } from "components/headers/light.js";
import { SectionHeading as HeadingBase } from "components/misc/Headings";
import { SectionDescription as DescriptionBase } from "components/misc/Typography";
import Header from "components/headers/light.js";

//import { ReactComponent as CheckboxIcon } from "feather-icons/dist/icons/check-circle.svg";
import GoogleDownloadImageSrc from "images/GetItOnGooglePlay_English.png";
import AppleDownloadImageSrc from "images/Download_on_the_App_Store_US.svg";
//import heatScreenshotImageSrc from "images/demo/MainLandingPageHero.png";
import RugbyImageSrc from "images/demo/Rugby.png";
//import logo from "images/gslogo.png";
//import ResponsiveVideoEmbed from "./helpers/ResponsiveVideoEmbed.js";

import Footer from "components/footers/FiveColumnWithInputForm.js";

/* Hero */
//const Row = tw.div`flex`;
//const NavRow = tw(Row)`flex flex-col lg:flex-row items-center justify-between`;
/*const HeroRow = tw(
    Row
)`flex-col lg:flex-row justify-between items-center pt-8 lg:pt-12 pb-16 max-w-screen-2xl mx-auto flex-wrap`;*/

//const Column = tw.div`flex-1`;

/*const TextColumn = tw(
    Column
)`mx-auto lg:mr-0 max-w-2xl lg:max-w-xl xl:max-w-2xl flex-shrink-0`;
const Heading = tw(
    HeadingBase
)`text-center lg:text-left text-primary-900 leading-snug`;
const Description = tw(
    DescriptionBase
)`mt-4 text-center lg:text-left lg:text-base text-gray-700 max-w-lg mx-auto lg:mx-0`;
const FeatureList = tw.ul`mt-6 leading-loose flex flex-wrap max-w-xl mx-auto lg:mx-0`;
const Feature = tw.li`mt-2 flex items-center flex-shrink-0 w-full sm:w-1/2 justify-center lg:justify-start`;
const FeatureIcon = tw(CheckboxIcon)`w-5 h-5 text-primary-500`;
const FeatureText = tw.p`ml-2 font-medium text-gray-700`;
const ImageColumn = tw(Column)`mx-auto lg:mr-0 relative mt-16 lg:mt-0 lg:ml-8`;
const ImageContainer = tw.div``;*/
const Image = tw.img`max-w-full rounded-t sm:rounded`;

const SectionContainer = tw(ContentWithVerticalPadding)``;
const SectionHeading = tw(HeadingBase)`text-primary-900`;
const SectionDescription = tw(
    DescriptionBase
)`text-center mx-auto text-gray-600 max-w-4xl`;

/*const StyledResponsiveVideoEmbed = styled(ResponsiveVideoEmbed)`
  padding-bottom: 56.25% !important;
  padding-top: 0px !important;
  ${tw`rounded`}
  iframe {
    ${tw`rounded bg-black shadow-xl`}
  }
`;*/

export default ({
    features = null,
    // innerPages = components.innerPages,
    // blocks = components.blocks,
    heading = "Welcome to the wonderful world of sports games!",
    description = "Every member of our team is driven by a love for sports and a dedication to game development. We are committed not only to creating realistic and exciting gaming environments but also to fostering a positive, vibrant community to share the charm and joy of sports with you.",
}) => {
    /*
     * Using gtag like this because we only want to use Google Analytics when Main Landing Page is rendered
     * Remove this part and the the gtag script inside public/index.html if you dont need google analytics
     */
    // useEffect(() => {
    //   window.gtag("js", new Date());
    //   window.gtag("config", "UA-45799926-9");
    // }, [])

    // const noOfLandingPages = Object.keys(landingPages).length;
    // const noOfInnerPages = Object.keys(innerPages).length;
    // const noOfComponentBlocks = Object.values(blocks).reduce(
    //   (acc, block) => acc + Object.keys(block.elements).length,
    //   0
    // );

    features =
        features ||
        [
            // `${noOfLandingPages} Landing Page Demos`,
            // `${noOfInnerPages} Inner Pages`,
            // `${noOfComponentBlocks} Components`,
            // "Uses TailwindCSS",
            // "Fully Responsive",
            // "Fully Customizable",
        ];

    return (
        <AnimationRevealPage disabled>
            <Header />
            <Container tw="bg-gray-100 -mx-8 -mt-8 pt-8 px-8">
                <Content2Xl>
                    
                    <SectionContainer id="landingPageDemos">
                        <SectionHeading>Rugby GOAT
                        </SectionHeading>
                        <SectionDescription>
                            Welcome to our rugby world! In this thrilling game, you'll step into the boots of a professional rugby player and experience the excitement of real-life matches and intense showdowns. Whether you're a rookie or a seasoned player, there's something here for everyone. Train to improve your skills, build your dream team, and challenge top clubs from around the globe to claim championship glory. Join us now and feel the magic of rugby!
                            <br />
                            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>Rugby GOAT Privacy Policy</a>
                        </SectionDescription>
                        <br />
                        <Image src={RugbyImageSrc} />
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                            <a href="https://play.google.com/store/apps/details?id=com.redfalcon.rugbygoat.android" target="_blank" rel="noopener noreferrer">
                                <Image src={GoogleDownloadImageSrc} alt="Download on Google Play" style={{ width: '200px', margin: '10px' }} />
                            </a>
                            <a href="https://apps.apple.com/us/app/baseball-goat/id6677019784" target="_blank" rel="noopener noreferrer">
                                <Image src={AppleDownloadImageSrc} alt="Download on Google Play" style={{ width: '200px', margin: '6px' }} />
                            </a>
                        </div>
                    </SectionContainer>
                    <div className="App">
                        <Footer />
                    </div>
                </Content2Xl>
            </Container>
        </AnimationRevealPage>
    );
};
